module.exports = __webpack_public_path__ + "assets/webgl/art_050_L0.ee5c0e87.jpg";